module.exports = __webpack_public_path__ + "img/callrail-bridget.9e6700f2.jpg";